// 401 не доказывает, что сервер ничего не сделал: POST или PATCH мог выполниться до отказа, и повтор
// после обновления токена выполнил бы операцию второй раз на один клик. Такой запрос не повторяем —
// вызывающий получает исходную ошибку, а сессия остаётся живой.
const NOT_REPLAYABLE_AFTER_REFRESH: ReadonlySet<string> = new Set(['POST', 'PATCH']);

// Метод HttpRequest Angular уже приводит к верхнему регистру.
export function canReplayAfterRefresh(method: string): boolean {
  return !NOT_REPLAYABLE_AFTER_REFRESH.has(method);
}

// Исходный 401 запроса, который не повторили после УДАЧНОГО обновления токена. Сессия жива, и такой 401
// не значит «вход чужой или умер»: вызывающий, который судит по 401 о входе, отличает его этим предикатом.
// Объект ошибки не подменяется — остальные потребители видят тот же HttpErrorResponse со статусом 401.
const NOT_REPLAYED_AFTER_REFRESH: WeakSet<object> = new WeakSet();

export function markNotReplayedAfterRefresh<T extends object>(error: T): T {
  NOT_REPLAYED_AFTER_REFRESH.add(error);
  return error;
}

export function isNotReplayedAfterRefresh(error: unknown): boolean {
  return typeof error === 'object' && error !== null && NOT_REPLAYED_AFTER_REFRESH.has(error);
}
